import Axios from "axios";
// import CryptoJS from 'crypto-js';
// import { size } from 'lodash';

const axios = Axios.create({
  // baseURL: "https://medicalcoding.clinion.com/cmthwebapi/",
  baseURL: " https://cmth.clinion.com/cmthstagemobileapi/",
  // baseURL: 'http://dev-api.crmemperor.com/',
});

// const secret = 'RJHRrdHIXnIujihrIIUlLiDheIhlaXli';

export default class Api {
  static get(config) {
    const { url, params } = config;
    try {
      return axios.get(url, { params: params });
    } catch (error) {
      console.log("getapiresponseErr==>", error);
    }
  }

  //   static async post(config) {
  //     const { url, data, header, ...restConfig } = config;
  //     let bodyData = CryptoJS.AES.encrypt(
  //       JSON.stringify(data),
  //       secret,
  //     ).toString();

  //     if (size(header) !== 0) {
  //       axios.defaults.headers.common['Authorization'] = header;
  //     }

  //     let req_data = { input_data: bodyData };
  //     let resp_data = await axios.post(url, req_data, restConfig);
  //     let bytes = CryptoJS.AES.decrypt(resp_data.data.output_data, secret);
  //     resp_data.data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //     return resp_data;
  //   }

  // static async masterPost(config) {
  //   const { url, data, ...restConfig } = config;
  //   let bodyData = CryptoJS.AES.encrypt(
  //     JSON.stringify(data),
  //     secret
  //   ).toString();
  //   let req_data = { input_data: bodyData };
  //   let resp_data = await masterAxios.post(url, req_data, restConfig);
  //   let bytes = CryptoJS.AES.decrypt(resp_data.data.output_data, secret);
  //   resp_data.data = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //   return resp_data;
  // }

  //   static async post2(config) {
  //     const { url, data, ...restConfig } = config;
  //     let resp_data = await axios.post(url, data, restConfig);
  //     return resp_data;
  //   }
  static post(config) {
    const { url, data, ...restConfig } = config;
    // console.log("url =>", url);
    try {
      return axios.post(url, data, restConfig);
      // return Api.post_data(url, data, restConfig);
    } catch (err) {
      console.log("API Post error ---> ", err.message);
    }
  }
}
